import { combineReducers } from 'redux';
import Compensate from './Compensate';

const reducers = combineReducers({
    compensate: Compensate,
});

export default reducers;
